
/**
 * Feedback form
 */
 import feedback_form from './admin/feedback-form';

 feedback_form()